import { render, staticRenderFns } from "./hotelProductInquiry.vue?vue&type=template&id=2f8f55c7&scoped=true"
import script from "./hotelProductInquiry.vue?vue&type=script&lang=js"
export * from "./hotelProductInquiry.vue?vue&type=script&lang=js"
import style0 from "./hotelProductInquiry.vue?vue&type=style&index=0&id=2f8f55c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f55c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8f55c7')) {
      api.createRecord('2f8f55c7', component.options)
    } else {
      api.reload('2f8f55c7', component.options)
    }
    module.hot.accept("./hotelProductInquiry.vue?vue&type=template&id=2f8f55c7&scoped=true", function () {
      api.rerender('2f8f55c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/child/hotelProductInquiry.vue"
export default component.exports